var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid content",attrs:{"id":"shop"}},[_c('iframe',{attrs:{"src":"https://shop.spreadshirt.de/sandkastenliga","align":"middle","width":"1017px","height":"900px","border":"0"}})])
}]

export { render, staticRenderFns }